import styled from 'styled-components'  
import { AKAMAI_ENDPOINT } from 'services/api';

export const LoginSpacer = styled.div.attrs({ 
})`            
`;
 
export const CentredContent = styled.div.attrs({ 
})`  
    padding-top: 215px;
    max-width: 480px;      
    margin: 0 auto;
    
    @media (max-width: 768px) {
        padding-top: 160px;
        max-width: 90%;
    }

    ${
        props => props.big ? `
            padding-top: 310px;
        ` : ``
    }
`;

export const WhiteCard = styled.div.attrs({ 
})`           
    padding: 20px 16px 25px;
    background: var(--white-color);
    border-radius: 16px;
    box-shadow: var(--elev-2);
`;
 
export const CardTitle = styled.div.attrs({ 
})`           
    color: var(--jk-text);
    font-size: 20px;
    font-weight: bold;
    margin: 0 10px;

    ${
        props => props.centred ? `
            text-align: center;
        ` : ``
    }
`;
 
export const CardText = styled.div.attrs({ 
})`           
    color: var(--jk-muted);
    font-size: 14px;
    text-align: center;
`;
 



export const WrapUsers = styled.div.attrs({ 
})`
    justify-content: center;   
    padding: 20px 0;
    display: flex;  
    gap: 0 25px;
`;


export const UserItem = styled.div.attrs({ 
})`       
    width: 76px;
    height: 76px;
    border-radius: 38px;
    position: relative;
    box-shadow: var(--elev-1);

    ${
        props => props.image ? `
            background: url(${ props.image }) no-repeat center center / cover;
        ` : `
            background: var(--jk-bg);
            border: 3px dashed var(--jk-secondary);
            &:after{
                content:"+"; 
                width: 24px;
                height: 24px;
                border-radius: 12px;
                background: var(--jk-secondary);
        
                display: flex;
                align-items: center;
                justify-content: center;
        
                position: absolute;
                bottom: -3px;
                right: -6px;
        
                color: var(--white-color);
                font-size: 18px;
                font-weight: bold;
            }
        `
    }

    cursor:pointer;
    transition: transform .08s ease;
    &:hover{
        transform: scale(1.03);
    }
`;
  
export const UserTitle = styled.div.attrs({ 
})`           
    color: var(--jk-primary);
    font-size: 30px;
    font-weight: bold; 
    text-align: center;
`; 
  
export const UserSelected = styled.div.attrs({ 
})`           
    width: 112px;
    height: 112px;
    border-radius: 56px;

    margin: 7px auto;

    background: url(${ props => props.image }) no-repeat center center / cover;
    box-shadow: var(--elev-2);
`; 

export const SelectProfileContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  text-align: center;
`;

export const SelectProfileTitle = styled.h1`
  color: var(--jk-text);
  font-size: 32px;
  margin-bottom: 10px;
`;

export const SelectProfileSubtitle = styled.p`
  color: var(--jk-text);
  font-size: 18px;
  margin-bottom: 40px;
`;

export const BackToDashboardButton = styled.button`
  background: var(--jk-secondary);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 30px;
  transition: filter .2s ease, transform .05s ease;
  
  &:hover {
    filter: brightness(0.95);
  }
  &:active {
    transform: translateY(1px);
  }
`;

export const ProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
`;

export const ProfileItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
`;

export const ProfileImage = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  cursor: pointer;
  border: 3px solid ${props => props.active ? 'var(--jk-primary)' : 'var(--jk-yellow)'};
  transition: border-color 0.3s, box-shadow .2s ease;
  
  &:hover {
    border-color: var(--jk-primary);
  }
  
  ${props => props.active && `
    box-shadow: 0 0 0 4px rgba(94, 198, 255, 0.25);
  `}
`;

export const ProfileName = styled.p`
  color: ${props => props.active ? 'var(--jk-primary)' : 'var(--jk-text)'};
  font-size: 16px;
  margin: 15px 0;
  font-weight: ${props => props.active ? 'bold' : 'normal'};
`;

export const AddProfileButton = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background-color: var(--jk-bg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s, transform .05s ease;
  border: 3px dashed var(--jk-secondary);
  
  span {
    font-size: 40px;
    color: var(--jk-secondary);
    margin-bottom: 5px;
    line-height: 1;
  }
  
  p {
    color: var(--jk-secondary);
    font-size: 14px;
  }
  
  &:hover {
    background-color: var(--jk-secondary);
    span, p { color: white; }
  }
  &:active { transform: translateY(1px); }
`;

export const EditProfileButton = styled.button`
  background: ${props => props.delete ? 'var(--jk-error)' : 'var(--jk-text)'};
  color: white;
  border: none;
  border-radius: 12px;
  padding: 8px 12px;
  margin-top: 5px;
  cursor: pointer;
  transition: filter 0.2s;
  font-size: 14px;
  width: 120px;
  
  &:hover {
    filter: brightness(0.95);
  }
`;

// Modal de edição de perfil
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: var(--white-color);
  border-radius: 16px;
  padding: 30px;
  width: 90%;
  max-width: 420px;
  text-align: center;
  box-shadow: var(--elev-2);
`;

export const ModalTitle = styled.h2`
  color: var(--jk-text);
  margin-bottom: 20px;
  font-size: 24px;
`;

export const AvatarEditContainer = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AvatarEditPreview = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  margin-bottom: 15px;
  border: 3px solid var(--jk-primary);
`;

export const ChangeImageButton = styled.button`
  background: var(--jk-primary);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 20px;
  transition: filter .2s ease, transform .05s ease;
  
  &:hover {
    filter: brightness(0.95);
  }
  &:active { transform: translateY(1px); }
`;

export const ModalButtons = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
`;

export const ModalButton = styled.button`
  background: ${props => props.primary ? 'var(--jk-secondary)' : 'var(--jk-muted)'};
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 24px;
  cursor: pointer;
  font-size: 14px;
  min-width: 100px;
  transition: filter .2s ease, transform .05s ease;
  
  &:hover {
    filter: brightness(0.95);
  }
  &:active { transform: translateY(1px); }
  
  &:disabled {
    background: var(--jk-muted);
    cursor: not-allowed;
  }
`; 